import { PowerBIEmbed } from "powerbi-client-react";
import { models } from "powerbi-client";
export function ReportViewer({ config }) {
  return (
    <PowerBIEmbed
      embedConfig={{
        type: "report", // Supported types: report, dashboard, tile, visual and qna
        id: config.id,
        embedUrl: config.embedUrl,
        accessToken: config.accessToken,
        tokenType: models.TokenType.Aad,
        settings: {
          panes: {
            filters: {
              expanded: false,
              visible: false
            }
          },
          background: models.BackgroundType.Transparent
        }
      }}
      eventHandlers={
        new Map([
          [
            "loaded",
            function () {
              console.log("Report loaded");
            }
          ],
          [
            "rendered",
            function () {
              console.log("Report rendered");
            }
          ],
          [
            "error",
            function (event) {
              console.log(event.detail);
            }
          ]
        ])
      }
      cssClassName={"report-style-class"}
      getEmbeddedComponent={(embeddedReport) => {
        window.report = embeddedReport;
      }}
    />
  );
}
